function NewsletterForm() {
  return (
    <div className="h-auto">
      <iframe 
        src="https://preview.mailerlite.io/forms/2207766/182429064655537707/share" 
        width="100%"
        height="240"
        title="Newsletter Signup"
      ></iframe>
    </div>
  );
};

export default NewsletterForm;